import { Link } from "react-router-dom";
import Layout from "./Layout";
import Img_vector from '../assets/Vector.svg';
import React, { useMemo, useState } from "react";
import {
    useTable,
    useSortBy,
    useFilters,
} from "react-table";

function Negotiation({ username, onSignOut }) {
    const data = useMemo(
        () => [
            {
                created: "1/5/25",
                projectId: "PCT1",
                description: "Chamber Vacuum",
                category: "Mechanical Part",
                subcategory: "Chamber Body",
                location: "US",
                supplier: "Magna Chassis Solutions",
                spend: "$4.8M",
            },
            {
                created: "2/3/25",
                projectId: "PCT2",
                description: "Chamber Vacuum",
                category: "Mechanical Part",
                subcategory: "Chamber Body",
                location: "Vietnam",
                supplier: "DRB-HICOM Group",
                spend: "$3.1M",
            },
            {
                created: "1/8/25",
                projectId: "PCT3",
                description: "Chamber Vacuum",
                category: "Mechanical Part",
                subcategory: "Chamber Body",
                location: "Malaysia",
                supplier: "Vietnam Auto Parts",
                spend: "$3.0M",
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            { Header: "Created Date", accessor: "created" },
            { Header: "Project ID", accessor: "projectId" },
            { Header: "Description", accessor: "description" },
            { Header: "Category", accessor: "category" },
            { Header: "Subcategory", accessor: "subcategory" },
            { Header: "Mfg. Location", accessor: "location" },
            { Header: "Supplier", accessor: "supplier" },
            { Header: "Spend", accessor: "spend" },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        { columns, data },
        useFilters,
        useSortBy
    );

    const [searchTerm, setSearchTerm] = useState("");
    const [selectedProjectId, setSelectedProjectId] = useState(null);

    const filteredRows = rows.filter((row) =>
        Object.values(row.values).some((val) =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    return (
        <Layout username={username} onSignOut={onSignOut}>
            <div className="container-fluid Home gap-10">
                <div className='row'>
                    <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
                        <Link to="/">
                            <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
                                </svg>
                                <span className="SummaryText">Home</span>
                            </span>
                        </Link>
                        <span>/</span>
                        <span className="HomeText">Negotiation Strategy</span>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-1'></div>
                    <div className='col-10 flex justify-center'>
                        <div className="text-3xl text-[#A100FF] font-semibold">Select a Project to Continue</div>
                    </div>
                    <div className='col-1'></div>
                </div>
                <div className="row mt-3">
                    <div className="col-2"></div>
                    <div className="col-8">
                        <div className="LandingSearchBar">
                            <div className="LandingSearchBar-search">
                                <img src={Img_vector} alt="Img_vector" className="w-4 h-4 mr-2" />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className="w-full outline-none"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-2"></div>
                </div>

                <div className="overflow-x-auto p-4">
                    <table
                        {...getTableProps()}
                        className="min-w-full border border-gray-300 bg-white shadow-md rounded-lg"
                    >
                        <thead className="bg-[#E6DCFF]">
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {/* Extra column header for radio */}

                                    <th className="!px-3 py-2 border-b"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="black" />
                                    </svg></th>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className="!px-4 py-2 text-left text-sm font-semibold text-gray-700 border-b cursor-pointer select-none"
                                        >
                                            <div className="flex items-center gap-2">
                                                {column.render("Header")}
                                                <span className="flex flex-row w-[15px]">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-up" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {filteredRows.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()} className="hover:bg-[#f4f3ff]">
                                        {/* Radio button cell */}
                                        <td className="!px-4 py-2 text-sm border-b">
                                            <input
                                                type="radio"
                                                name="selectedProject"
                                                checked={selectedProjectId === row.original.projectId}
                                                onChange={() => setSelectedProjectId(row.original.projectId)}
                                            />
                                        </td>
                                        {row.cells.map((cell) => (
                                            <td
                                                {...cell.getCellProps()}
                                                className="!px-4 py-2 text-sm border-b"
                                            >
                                                {cell.render("Cell")}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                {selectedProjectId !== null && (
                    <div className="mt-4 text-center text-lg text-green-600">
                        Selected Project ID: {selectedProjectId}
                    </div>
                )}
            </div>
        </Layout>
    )
}
export default Negotiation;
